import { useState, useEffect, useCallback } from "react";

// Tema konfigürasyonu - Tüm renk ayarları tek yerde
const THEME_CONFIG = {
  general: {
    backgroundColor: {
      key: "appBackgroundColor",
      cssVar: "--app-background-color",
      default: "#060b10",
      label: "Arka Plan Rengi",
    },
  },
  header: {
    titleColor: {
      key: "headerTitleColor",
      cssVar: "--header-title-color",
      default: "#ffffff",
      label: "Başlık Rengi",
    },
    subtitleColor: {
      key: "headerSubtitleColor",
      cssVar: "--header-subtitle-color",
      default: "#e0e0e0",
      label: "Alt Başlık Rengi",
    },
    iconColor: {
      key: "headerIconColor",
      cssVar: "--header-icon-color",
      default: "#ffffff",
      label: "İkon Rengi",
    },
    iconBgColor: {
      key: "headerIconBgColor",
      cssVar: "--header-icon-bg-color",
      default: "rgba(255, 255, 255, 0.1)",
      label: "İkon Arka Plan Rengi",
    },
  },
  mainCategory: {
    bgColor: {
      key: "mainCategoryBgColor",
      cssVar: "--main-category-bg-color",
      default: "#0E212E",
      label: "Arka Plan Rengi",
    },
    textColor: {
      key: "mainCategoryTextColor",
      cssVar: "--main-category-text-color",
      default: "#FFFFFF",
      label: "Yazı Rengi",
    },
    iconColor: {
      key: "mainCategoryIconColor",
      cssVar: "--main-category-icon-color",
      default: "#FFFFFF",
      label: "İkon Rengi",
    },
    activeBgColor: {
      key: "mainCategoryActiveBgColor",
      cssVar: "--main-category-active-bg-color",
      default: "#1375E1",
      label: "Aktif Arka Plan Rengi",
    },
    activeGlowColor: {
      key: "mainCategoryActiveGlowColor",
      cssVar: "--main-category-active-glow-color",
      default: "rgba(19, 117, 225, 0.3)",
      label: "Aktif Parıltı Rengi",
    },
  },
  tab: {
    bgColor: {
      key: "tabBgColor",
      cssVar: "--tab-bg-color",
      default: "#335166",
      label: "Arka Plan Rengi",
    },
    textColor: {
      key: "tabTextColor",
      cssVar: "--tab-text-color",
      default: "#FFFFFF",
      label: "Yazı Rengi",
    },
    iconColor: {
      key: "tabIconColor",
      cssVar: "--tab-icon-color",
      default: "#FFFFFF",
      label: "İkon Rengi",
    },
    activeBgColor: {
      key: "tabActiveBgColor",
      cssVar: "--tab-active-bg-color",
      default: "#1375E1",
      label: "Aktif Arka Plan Rengi",
    },
    activeGlowColor: {
      key: "tabActiveGlowColor",
      cssVar: "--tab-active-glow-color",
      default: "rgba(19, 117, 225, 0.3)",
      label: "Aktif Parıltı Rengi",
    },
  },
  bonusButtons: {
    requestBgColor: {
      key: "bonusRequestBgColor",
      cssVar: "--bonus-request-bg-color",
      default: "#1375E1",
      label: "Talep Et - Arka Plan Rengi",
    },
    requestTextColor: {
      key: "bonusRequestTextColor",
      cssVar: "--bonus-request-text-color",
      default: "#FFFFFF",
      label: "Talep Et - Yazı Rengi",
    },
    requestHoverBgColor: {
      key: "bonusRequestHoverBgColor",
      cssVar: "--bonus-request-hover-bg-color",
      default: "#0F5FC4",
      label: "Talep Et - Hover Arka Plan",
    },
    requestGlowColor: {
      key: "bonusRequestGlowColor",
      cssVar: "--bonus-request-glow-color",
      default: "rgba(20, 117, 225, 0.4)",
      label: "Talep Et - Parıltı Rengi",
    },
    requestHoverGlowColor: {
      key: "bonusRequestHoverGlowColor",
      cssVar: "--bonus-request-hover-glow-color",
      default: "rgba(20, 117, 225, 0.5)",
      label: "Talep Et - Hover Parıltı",
    },
    rulesBgColor: {
      key: "bonusRulesBgColor",
      cssVar: "--bonus-rules-bg-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Kurallar - Arka Plan Rengi",
    },
    rulesTextColor: {
      key: "bonusRulesTextColor",
      cssVar: "--bonus-rules-text-color",
      default: "#FFFFFF",
      label: "Kurallar - Yazı Rengi",
    },
    rulesHoverBgColor: {
      key: "bonusRulesHoverBgColor",
      cssVar: "--bonus-rules-hover-bg-color",
      default: "rgba(255, 255, 255, 0.3)",
      label: "Kurallar - Hover Arka Plan",
    },
    rulesGlowColor: {
      key: "bonusRulesGlowColor",
      cssVar: "--bonus-rules-glow-color",
      default: "rgba(44, 73, 92, 0.4)",
      label: "Kurallar - Parıltı Rengi",
    },
    rulesHoverGlowColor: {
      key: "bonusRulesHoverGlowColor",
      cssVar: "--bonus-rules-hover-glow-color",
      default: "rgba(44, 73, 92, 0.5)",
      label: "Kurallar - Hover Parıltı",
    },
  },
  rulesPopup: {
    backgroundColor: {
      key: "rulesPopupBgColor",
      cssVar: "--rules-popup-bg-color",
      default: "#1A2C38",
      label: "Popup Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "rulesPopupHeaderTitleColor",
      cssVar: "--rules-popup-header-title-color",
      default: "#FFFFFF",
      label: "Başlık Rengi",
    },
    subtitleColor: {
      key: "rulesPopupSubtitleColor",
      cssVar: "--rules-popup-subtitle-color",
      default: "rgba(255, 255, 255, 0.8)",
      label: "Kurallar ve Koşullar Yazısı",
    },
    closeIconColor: {
      key: "rulesPopupCloseIconColor",
      cssVar: "--rules-popup-close-icon-color",
      default: "white",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "rulesPopupCloseIconBgColor",
      cssVar: "--rules-popup-close-icon-bg-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Çarpı İkonu Arka Plan",
    },
    ruleContentBgColor: {
      key: "rulesPopupRuleContentBgColor",
      cssVar: "--rules-popup-rule-content-bg-color",
      default: "rgba(15, 33, 46, 0.6)",
      label: "Kural İçerik Arka Plan",
    },
    ruleTitleColor: {
      key: "rulesPopupRuleTitleColor",
      cssVar: "--rules-popup-rule-title-color",
      default: "rgba(255, 255, 255, 0.9)",
      label: "Kural Başlık Rengi",
    },
    ruleTextColor: {
      key: "rulesPopupRuleTextColor",
      cssVar: "--rules-popup-rule-text-color",
      default: "rgba(255, 255, 255, 0.7)",
      label: "Kural Metin Rengi",
    },
    ruleNumberBgColor: {
      key: "rulesPopupRuleNumberBgColor",
      cssVar: "--rules-popup-rule-number-bg-color",
      default: "#1375E1",
      label: "Kural Numarası Arka Plan",
    },
    ruleNumberTextColor: {
      key: "rulesPopupRuleNumberTextColor",
      cssVar: "--rules-popup-rule-number-text-color",
      default: "#FFFFFF",
      label: "Kural Numarası Yazı Rengi",
    },
    ruleContentHoverBgColor: {
      key: "rulesPopupRuleContentHoverBgColor",
      cssVar: "--rules-popup-rule-content-hover-bg-color",
      default: "rgba(20, 40, 55, 0.6)",
      label: "Kural İçerik Hover Arka Plan",
    },
    footerBgColor: {
      key: "rulesPopupFooterBgColor",
      cssVar: "--rules-popup-footer-bg-color",
      default: "rgba(15, 33, 46, 0.5)",
      label: "Footer Arka Plan Rengi",
    },
    closeButtonBgColor: {
      key: "rulesPopupCloseButtonBgColor",
      cssVar: "--rules-popup-close-button-bg-color",
      default: "rgba(20, 117, 225, 0.9)",
      label: "Anladım Butonu Arka Plan",
    },
    closeButtonTextColor: {
      key: "rulesPopupCloseButtonTextColor",
      cssVar: "--rules-popup-close-button-text-color",
      default: "#FFFFFF",
      label: "Anladım Butonu Yazı Rengi",
    },
    closeButtonHoverBgColor: {
      key: "rulesPopupCloseButtonHoverBgColor",
      cssVar: "--rules-popup-close-button-hover-bg-color",
      default: "rgba(20, 117, 225, 1)",
      label: "Anladım Butonu Hover Arka Plan",
    },
    scrollbarTrackColor: {
      key: "rulesPopupScrollbarTrackColor",
      cssVar: "--rules-popup-scrollbar-track-color",
      default: "#0f212e",
      label: "Scroll Bar Arka Plan Rengi",
    },
    scrollbarThumbColor: {
      key: "rulesPopupScrollbarThumbColor",
      cssVar: "--rules-popup-scrollbar-thumb-color",
      default: "#2c495c",
      label: "Scroll Bar Rengi",
    },
    scrollbarThumbHoverColor: {
      key: "rulesPopupScrollbarThumbHoverColor",
      cssVar: "--rules-popup-scrollbar-thumb-hover-color",
      default: "#3a5a6e",
      label: "Scroll Bar Hover Rengi",
    },
  },
  historyPopup: {
    backgroundColor: {
      key: "historyPopupBgColor",
      cssVar: "--history-popup-bg-color",
      default: "#1A2C38",
      label: "Popup Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "historyPopupHeaderTitleColor",
      cssVar: "--history-popup-header-title-color",
      default: "#FFFFFF",
      label: "Başlık Rengi (Talep Geçmişi)",
    },
    closeIconColor: {
      key: "historyPopupCloseIconColor",
      cssVar: "--history-popup-close-icon-color",
      default: "#FFFFFF",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "historyPopupCloseIconBgColor",
      cssVar: "--history-popup-close-icon-bg-color",
      default: "#0F212E",
      label: "Çarpı İkonu Arka Plan",
    },
    itemBgColor: {
      key: "historyPopupItemBgColor",
      cssVar: "--history-popup-item-bg-color",
      default: "#0F212E",
      label: "Geçmiş Öğesi Arka Plan",
    },
    itemBorderColor: {
      key: "historyPopupItemBorderColor",
      cssVar: "--history-popup-item-border-color",
      default: "#2C495C",
      label: "Geçmiş Öğesi Kenarlık",
    },
    dateBgColor: {
      key: "historyPopupDateBgColor",
      cssVar: "--history-popup-date-bg-color",
      default: "transparent",
      label: "Tarih Bölümü Arka Plan",
    },
    dateTextColor: {
      key: "historyPopupDateTextColor",
      cssVar: "--history-popup-date-text-color",
      default: "#FFFFFF",
      label: "Tarih Yazı Rengi",
    },
    contentTitleColor: {
      key: "historyPopupContentTitleColor",
      cssVar: "--history-popup-content-title-color",
      default: "#FFFFFF",
      label: "İçerik Başlık Rengi",
    },
    successMessageColor: {
      key: "historyPopupSuccessMessageColor",
      cssVar: "--history-popup-success-message-color",
      default: "#4CAF50",
      label: "Başarılı Mesaj Rengi",
    },
    errorMessageColor: {
      key: "historyPopupErrorMessageColor",
      cssVar: "--history-popup-error-message-color",
      default: "#F44336",
      label: "Hata Mesaj Rengi",
    },
    loadingTextColor: {
      key: "historyPopupLoadingTextColor",
      cssVar: "--history-popup-loading-text-color",
      default: "#FFFFFF",
      label: "Yükleniyor Yazı Rengi",
    },
    emptyTextColor: {
      key: "historyPopupEmptyTextColor",
      cssVar: "--history-popup-empty-text-color",
      default: "rgba(255, 255, 255, 0.7)",
      label: "Boş Durum Yazı Rengi",
    },
  },
  multipleBonusDialog: {
    backgroundColor: {
      key: "multipleBonusDialogBgColor",
      cssVar: "--multiple-bonus-dialog-bg-color",
      default: "#1A2C38",
      label: "Dialog Arka Plan Rengi",
    },
    headerTitleColor: {
      key: "multipleBonusDialogHeaderTitleColor",
      cssVar: "--multiple-bonus-dialog-header-title-color",
      default: "#FFFFFF",
      label: "Başlık Rengi (Lütfen Bonus Seç)",
    },
    headerSubtitleColor: {
      key: "multipleBonusDialogHeaderSubtitleColor",
      cssVar: "--multiple-bonus-dialog-header-subtitle-color",
      default: "rgba(255, 255, 255, 0.8)",
      label: "Alt Başlık Rengi",
    },
    iconColor: {
      key: "multipleBonusDialogIconColor",
      cssVar: "--multiple-bonus-dialog-icon-color",
      default: "#1375E1",
      label: "Hediye İkonu Rengi",
    },
    closeIconColor: {
      key: "multipleBonusDialogCloseIconColor",
      cssVar: "--multiple-bonus-dialog-close-icon-color",
      default: "#FFFFFF",
      label: "Çarpı İkonu Rengi",
    },
    closeIconBgColor: {
      key: "multipleBonusDialogCloseIconBgColor",
      cssVar: "--multiple-bonus-dialog-close-icon-bg-color",
      default: "#0F212E",
      label: "Çarpı İkonu Arka Plan",
    },
    closeIconHoverBgColor: {
      key: "multipleBonusDialogCloseIconHoverBgColor",
      cssVar: "--multiple-bonus-dialog-close-icon-hover-bg-color",
      default: "#152B3C",
      label: "Çarpı İkonu Hover Arka Plan",
    },
    optionButtonBgColor: {
      key: "multipleBonusDialogOptionButtonBgColor",
      cssVar: "--multiple-bonus-dialog-option-button-bg-color",
      default: "#1375E1",
      label: "Seçenek Butonu Arka Plan",
    },
    optionButtonTextColor: {
      key: "multipleBonusDialogOptionButtonTextColor",
      cssVar: "--multiple-bonus-dialog-option-button-text-color",
      default: "#FFFFFF",
      label: "Seçenek Butonu Yazı Rengi",
    },
    optionButtonHoverBgColor: {
      key: "multipleBonusDialogOptionButtonHoverBgColor",
      cssVar: "--multiple-bonus-dialog-option-button-hover-bg-color",
      default: "#0F5FC4",
      label: "Seçenek Butonu Hover Arka Plan",
    },
    optionButtonGlowColor: {
      key: "multipleBonusDialogOptionButtonGlowColor",
      cssVar: "--multiple-bonus-dialog-option-button-glow-color",
      default: "rgba(19, 117, 225, 0.4)",
      label: "Seçenek Butonu Parıltı Rengi",
    },
    optionButtonHoverGlowColor: {
      key: "multipleBonusDialogOptionButtonHoverGlowColor",
      cssVar: "--multiple-bonus-dialog-option-button-hover-glow-color",
      default: "rgba(19, 117, 225, 0.5)",
      label: "Seçenek Butonu Hover Parıltı",
    },
    separatorTextColor: {
      key: "multipleBonusDialogSeparatorTextColor",
      cssVar: "--multiple-bonus-dialog-separator-text-color",
      default: "rgba(255, 255, 255, 0.6)",
      label: "Ayırıcı Yazı Rengi (veya)",
    },
    separatorLineColor: {
      key: "multipleBonusDialogSeparatorLineColor",
      cssVar: "--multiple-bonus-dialog-separator-line-color",
      default: "rgba(255, 255, 255, 0.2)",
      label: "Ayırıcı Çizgi Rengi",
    },
  },
  bonusCard: {
    brightness: {
      type: "range",
      key: "bonusCardBrightness",
      cssVar: "--bonus-card-brightness",
      default: "1",
      label: "Bonus Kart Parıltı",
    },
    color: {
      key: "bonusCardColor",
      cssVar: "--bonus-card-color",
      default: "#1375E1",
      label: "Bonus Kart Parıltı Rengi",
    },
  },
  bonusConfirmPopup: {
    popupBgColor: {
      key: "bonusConfirmPopupBgColor",
      cssVar: "--bonus-confirm-popup-bg-color",
      default: "#1a2c38",
      label: "Popup Arka Plan Rengi",
    },
    popupBorderColor: {
      key: "bonusConfirmPopupBorderColor",
      cssVar: "--bonus-confirm-popup-border-color",
      default: "rgba(255, 255, 255, 0.38)",
      label: "Popup Kenarlık Rengi",
    },
    titleColor: {
      key: "bonusConfirmTitleColor",
      cssVar: "--bonus-confirm-title-color",
      default: "#ffffff",
      label: "Bonus Başlık Rengi",
    },
    questionColor: {
      key: "bonusConfirmQuestionColor",
      cssVar: "--bonus-confirm-question-color",
      default: "#ffffff",
      label: "Soru Metni Rengi",
    },
    imageBorderColor: {
      key: "bonusConfirmImageBorderColor",
      cssVar: "--bonus-confirm-image-border-color",
      default: "#2c495c",
      label: "Resim Kenarlık Rengi",
    },
    confirmButtonBgColor: {
      key: "bonusConfirmButtonBgColor",
      cssVar: "--bonus-confirm-button-bg-color",
      default: "#1475E1",
      label: "Talep Et Butonu Arka Plan",
    },
    confirmButtonTextColor: {
      key: "bonusConfirmButtonTextColor",
      cssVar: "--bonus-confirm-button-text-color",
      default: "#ffffff",
      label: "Talep Et Butonu Yazı Rengi",
    },
    cancelButtonBgColor: {
      key: "bonusCancelButtonBgColor",
      cssVar: "--bonus-cancel-button-bg-color",
      default: "#557086",
      label: "Vazgeç Butonu Arka Plan",
    },
    cancelButtonTextColor: {
      key: "bonusCancelButtonTextColor",
      cssVar: "--bonus-cancel-button-text-color",
      default: "#ffffff",
      label: "Vazgeç Butonu Yazı Rengi",
    },
    closeButtonColor: {
      key: "bonusConfirmCloseButtonColor",
      cssVar: "--bonus-confirm-close-button-color",
      default: "#ffffff",
      label: "Kapatma Butonu Rengi",
    },
    closeButtonBgColor: {
      key: "bonusConfirmCloseButtonBgColor",
      cssVar: "--bonus-confirm-close-button-bg-color",
      default: "rgba(255, 255, 255, 0.1)",
      label: "Kapatma Butonu Arka Plan",
    },
  },
};

// Tüm renk değerlerini düzleştir
const flattenThemeConfig = (config) => {
  const flattened = {};
  Object.keys(config).forEach((section) => {
    Object.keys(config[section]).forEach((property) => {
      const key = `${section}_${property}`;
      flattened[key] = config[section][property];
    });
  });
  return flattened;
};

const FLAT_CONFIG = flattenThemeConfig(THEME_CONFIG);

// Tema yönetimi hook'u
export const useThemeManager = () => {
  // Tüm tema değerlerini sadece default değerlerle başlat
  const [themeValues, setThemeValues] = useState(() => {
    const initialValues = {};
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const config = FLAT_CONFIG[key];
      // localStorage kaldırıldı - sadece default değerler
      initialValues[key] = config.default;
    });
    return initialValues;
  });

  // CSS değişkenlerini güncelle
  const updateCSSVariable = useCallback((cssVar, value) => {
    document.documentElement.style.setProperty(cssVar, value);
  }, []);

  // Tema değerini güncelle (sadece state'te tut, localStorage yok)
  const updateThemeValue = useCallback(
    (key, value) => {
      const config = FLAT_CONFIG[key];
      if (!config) return;

      setThemeValues((prev) => ({ ...prev, [key]: value }));
      updateCSSVariable(config.cssVar, value);
      // localStorage kaldırıldı
    },
    [updateCSSVariable]
  );

  // API'den gelen CSS değerleri ile sync et
  const syncFromApi = useCallback((apiCssData) => {
    if (!apiCssData || typeof apiCssData !== 'object') {
      // API verisi yoksa default değerleri uygula
      console.log('🎨 API verisi yok, default CSS değerleri uygulanıyor...');
      Object.keys(FLAT_CONFIG).forEach((key) => {
        const config = FLAT_CONFIG[key];
        setThemeValues((prev) => ({ ...prev, [key]: config.default }));
        updateCSSVariable(config.cssVar, config.default);
      });
      console.log('✅ Default CSS değerleri uygulandı:', Object.keys(FLAT_CONFIG).length, 'özellik');
      return;
    }

    console.log('🔄 API\'den gelen CSS verileri tema manager\'a sync ediliyor...');
    
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const config = FLAT_CONFIG[key];
      const apiValue = apiCssData[config.cssVar];
      
      if (apiValue) {
        setThemeValues((prev) => ({ ...prev, [key]: apiValue }));
        updateCSSVariable(config.cssVar, apiValue);
      } else {
        // API'de bu CSS değeri yoksa default kullan
        setThemeValues((prev) => ({ ...prev, [key]: config.default }));
        updateCSSVariable(config.cssVar, config.default);
      }
    });
    console.log('✅ CSS verileri tema manager\'a sync edildi');
  }, [updateCSSVariable]);

  // Tüm tema ayarlarını default değerlere sıfırla
  const resetToDefaults = useCallback(() => {
    console.log('🔄 Tema ayarları default değerlere sıfırlanıyor...');
    Object.keys(FLAT_CONFIG).forEach((key) => {
      const config = FLAT_CONFIG[key];
      setThemeValues((prev) => ({ ...prev, [key]: config.default }));
      updateCSSVariable(config.cssVar, config.default);
      // localStorage temizleme kaldırıldı
    });
    console.log('✅ Tema ayarları default değerlere sıfırlandı');
  }, [updateCSSVariable]);

  // Global olarak erişim için window'a kaydet
  useEffect(() => {
    window.themeManager = { syncFromApi };
  }, [syncFromApi]);

  return {
    themeValues,
    themeConfig: THEME_CONFIG,
    flatConfig: FLAT_CONFIG,
    updateThemeValue,
    resetToDefaults,
    syncFromApi,
  };
};
